import { black } from 'styles/colors'

export const header1 = `
  font-size: 22px;
  font-weight: 500;
  color: ${black};
  letter-spacing: 0;
  line-height: 26px;
`

export const header2 = `
  font-size: 20px;
  font-weight: 500;
  color: ${black};
  letter-spacing: 0;
  line-height: 24px;
`

export const header3 = `
  font-size: 18px;
  font-weight: 500;
  color: ${black};
  letter-spacing: 0;
  line-height: 22px;
`

// TODO: not in use? Ask Bendik
export const header4 = `
  font-size: 16px;
  font-weight: 500;
  color: ${black};
  letter-spacing: 0;
  line-height: 22px;
`

export const header5 = `
  font-size: 14px;
  font-weight: 500;
  color: ${black};
  letter-spacing: 0;
  line-height: 20px;
`

export const title = `
  font-size: 16px;
  font-weight: 300;
  color: ${black};
  letter-spacing: 0;
  line-height: 22px;
`

export const body = `
  font-size: 14px;
  font-weight: 300;
  color: ${black};
  line-height: 20px;
`



// WEBPACK FOOTER //
// ./src/styles/texts.js